import styled from '@emotion/styled'

export const StyledHeaderBlock = styled.div`
  border-bottom: solid 1px var(--White90);
`
